/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface FinalOfferBody {
  /** The new final offer amount (must be higher than previous bid) */
  amount: number;
}

export interface FinalOfferResponse {
  /** Success message */
  message: string;
  /** The updated bid ID */
  bidId: number;
  /** The new offer amount */
  amount: number;
  /**
   * New deadline for consumer to accept/decline the final offer
   * @format date-time
   */
  newOfferEndTime: string;
}

export interface FeedbackRequest {
  /** Site identifier (e.g., "Baana") */
  site: string;
  /** User type submitting feedback */
  postedBy: "seller" | "dealer";
  /**
   * User's email address
   * @format email
   */
  email: string;
  /**
   * Feedback message content
   * @maxLength 5000
   */
  message: string;
  /** Optional user name */
  name?: string;
  /** Optional mobile number */
  mobile?: string;
  /** Subject from Baana feedback form (mapped to Nettix codes server-side) */
  issueType:
    | "posting_ad"
    | "login"
    | "registration"
    | "technical_error"
    | "other_feedback"
    | "business_info_changes"
    | "new_customer";
}

export interface AuctionItemDetailsStepRegnoAndMileage {
  /**
   * Vehicle mileage
   * @min 0
   * @max 250000
   */
  mileage: number;
  /** Mileage unit */
  mileageUnit?: MileageUnit;
}

export interface AuctionItemDetailsStepBasicCarInformation {
  /**
   * Vehicle mileage
   * @min 0
   * @max 250000
   */
  mileage: number;
  /** Mileage unit */
  mileageUnit?: MileageUnit;
}

export interface AuctionItemDetailsStepBasicInfo {
  /** Ownership of vehicle */
  ownership: VehicleOwnership;
  keyCount: number;
  /** State of maintenance book */
  maintenanceBook: MaintenanceBook;
  lastMaintenance?: LastMaintenance;
  inspectionInfo?: InspectionInfo;
}

export type AuctionItemDetailsStepVehicleConditions =
  AuctionItemDetailsStepBasicInfo & {
    summer: TireInfo;
    winter: TireInfo;
    timingSystemInfo: {
      /** Timing system of vehicle */
      timingSystem: TimingSystem;
      /** mileage */
      mileage?: number;
      /** Month when timing system was changed (1-12) */
      month?: number;
      /** Year when timing system was changed */
      year?: number;
    };
    windshieldInfo: {
      /** Condition of windshield */
      condition: WindshieldCondition;
      /** Additional info */
      freeText?: string;
      /** Windshield insurance */
      insurance?: boolean;
    };
  };

export type AuctionItemDetailsStepDamages =
  AuctionItemDetailsStepVehicleConditions & {
    accessoryInfo?: {
      /** e.g Classic, Elegance, Business Premium... */
      accessoryName?: string;
      accessories?: string[];
      /** Additional info */
      freeText?: string;
    };
  };

export type AuctionItemDetailsStepAccessories = AuctionItemDetailsStepDamages;

export type AuctionItemDetailsStepMedia = AuctionItemDetailsStepAccessories;

export type AuctionItemDetailsStepFreeDescription =
  AuctionItemDetailsStepDamages & {
    /** Free description of the vehicle */
    freeDescription?: string;
  };

export type AuctionItemDetailsStepDelivery =
  AuctionItemDetailsStepFreeDescription & {
    delivery: {
      /** How vehicle will be delivered to buyer */
      method: DeliveryMethod;
      /** How far away is seller ready to deliver the vehicle (in km) */
      range: number;
    };
  };

export type AuctionItemDetailsStepPriceEstimate =
  AuctionItemDetailsStepDelivery & {
    /** Bottom price estimate from Netwheels Mittaristo */
    priceEstimate?: number | null;
    /**
     * Mittaristo reliability score stored alongside the estimate
     * @min 0
     * @max 3
     */
    priceEstimateReliabilityIndicator?: number | null;
    /** Target price for the vehicle */
    targetPrice: number;
    /** Is the vehicle VAT deductible */
    vatDeductible: boolean;
  };

/** Initial details of AuctionItem to create draft version on AuctionItem entity */
export interface CreateAuctionStepRegnoAndMileage {
  itemState: "STEP_REGNO_AND_MILEAGE";
  vehicle: {
    /** Vehicle registration number. Used to create Vehicle entity */
    regNo: string;
    /** Type of vehicle i.e. car/moto/caravan (moto includes motorcycles, mopeds, scooters, ATVs, etc) */
    vehicleType: VehicleType;
  };
  auctionItemDetails: AuctionItemDetailsStepRegnoAndMileage;
}

export interface CreateAuctionStepBasicCarInformation {
  /** Combined auction item state listing covering all vehicle types */
  itemState: AuctionItemState;
  auctionItemDetails: AuctionItemDetailsStepBasicCarInformation;
  /** Static vehicle data from third party source (Trafi) */
  vehicle: VehicleDTO;
}

export interface CreateAuctionStepBasicInfo {
  /** Combined auction item state listing covering all vehicle types */
  itemState: AuctionItemState;
  auctionItemDetails: AuctionItemDetailsStepBasicInfo;
  /** Static vehicle data from third party source (Trafi) */
  vehicle: VehicleDTO;
}

export interface CreateAuctionStepVehicleConditions {
  /** Combined auction item state listing covering all vehicle types */
  itemState: AuctionItemState;
  auctionItemDetails: AuctionItemDetailsStepVehicleConditions;
  /** Static vehicle data from third party source (Trafi) */
  vehicle: VehicleDTO;
}

export interface CreateAuctionStepDamages {
  /** Combined auction item state listing covering all vehicle types */
  itemState: AuctionItemState;
  auctionItemDetails: AuctionItemDetailsStepDamages;
  /** Static vehicle data from third party source (Trafi) */
  vehicle: VehicleDTO;
}

export interface CreateAuctionStepAccessories {
  /** Combined auction item state listing covering all vehicle types */
  itemState: AuctionItemState;
  auctionItemDetails: AuctionItemDetailsStepAccessories;
  /** Static vehicle data from third party source (Trafi) */
  vehicle: VehicleDTO;
}

export interface CreateAuctionStepMedia {
  /** Combined auction item state listing covering all vehicle types */
  itemState: AuctionItemState;
  auctionItemDetails: AuctionItemDetailsStepMedia;
  /** Static vehicle data from third party source (Trafi) */
  vehicle: VehicleDTO;
  media: AuctionItemMediaDTO[];
}

export interface CreateAuctionStepFreeDescription {
  /** Combined auction item state listing covering all vehicle types */
  itemState: AuctionItemState;
  auctionItemDetails: AuctionItemDetailsStepFreeDescription;
  /** Static vehicle data from third party source (Trafi) */
  vehicle: VehicleDTO;
  media: AuctionItemMediaDTO[];
}

export interface CreateAuctionStepDelivery {
  /** Combined auction item state listing covering all vehicle types */
  itemState: AuctionItemState;
  auctionItemDetails: AuctionItemDetailsStepDelivery;
  /** Static vehicle data from third party source (Trafi) */
  vehicle: VehicleDTO;
  media: AuctionItemMediaDTO[];
}

export interface CreateAuctionStepPriceEstimate {
  /** Combined auction item state listing covering all vehicle types */
  itemState: AuctionItemState;
  auctionItemDetails: AuctionItemDetailsStepPriceEstimate;
  /** Static vehicle data from third party source (Trafi) */
  vehicle: VehicleDTO;
  media: AuctionItemMediaDTO[];
}

export interface CreateAuctionNew {
  /** Combined auction item state listing covering all vehicle types */
  itemState: AuctionItemState;
  /** Static vehicle data from third party source (Trafi) */
  vehicle: VehicleDTO;
  media?: AuctionItemMediaDTO[];
  auctionItemDetails: {
    /**
     * Vehicle mileage
     * @min 0
     * @max 250000
     */
    mileage?: number;
    /** Mileage unit */
    mileageUnit?: MileageUnit;
    /** Ownership of vehicle */
    ownership?: VehicleOwnership;
    keyCount?: number;
    /** State of maintenance book */
    maintenanceBook?: MaintenanceBook;
    /** Additional details about incomplete maintenance book */
    maintenanceBookInfo?: string;
    lastMaintenance?: LastMaintenance;
    inspectionInfo?: InspectionInfo;
    summer?: TireInfo;
    winter?: TireInfo;
    timingSystemInfo?: {
      /** Timing system of vehicle */
      timingSystem?: TimingSystem;
      /** mileage */
      mileage?: number;
      /** Month when timing system was changed (1-12) */
      month?: number;
      /** Year when timing system was changed */
      year?: number;
    };
    windshieldInfo?: {
      /** Condition of windshield */
      condition?: WindshieldCondition;
      /** Additional info */
      freeText?: string;
      /** Windshield insurance */
      insurance?: boolean;
    };
    damageInfo?: {
      extent?: (DamageExtent | DamageExtentMoto | DamageExtentCaravan)[];
      /** Additional info */
      freeText?: string;
      /** Whether the vehicle has been smoked in */
      smokedIn?: boolean | null;
    };
    accessoryInfo?: {
      /** e.g Classic, Elegance, Business Premium... */
      accessoryName?: string;
      /** List of accessories. Typed as string[] due to complications with API Gateway validation. */
      accessories?: string[];
      /** Accessories entered as free text */
      freeText?: string;
    };
    /** Free description of the vehicle */
    freeDescription?: string;
    delivery?: {
      /** How vehicle will be delivered to buyer */
      method?: DeliveryMethod;
      /** How far away is seller ready to deliver the vehicle (in km) */
      range?: number;
    };
    /** Estimate of the going price for the vehicle */
    priceEstimate?: number | null;
    /**
     * Mittaristo reliability score stored alongside the estimate
     * @min 0
     * @max 3
     */
    priceEstimateReliabilityIndicator?: number | null;
    /** Target price for the vehicle */
    targetPrice?: number;
    /** Is the vehicle VAT deductible */
    vatDeductible?: boolean;
    /** Duration in business days for the auction (1 or 2) */
    auctionDuration?: number;
  };
  /** Whether to attach the A-Katsastus Kuntoraportti to this listing */
  includeKuntoraportti?: boolean;
  /**
   * A-Katsastus inspection UUID to attach as Kuntoraportti
   * @format uuid
   */
  kuntoraporttiInspectionId?: string;
}

/** Initial details of AuctionItem to create draft version on AuctionItem entity */
export interface CreateAuction {
  vehicle: {
    /** Vehicle registration number. Used to create Vehicle entity */
    regNo: string;
    /**
     * Vehicle mileage
     * @min 0
     * @max 250000
     */
    mileage: number;
  };
  contactInfo: UserContactInfo;
}

/** Base interface of Auction DTO that others extend */
export interface AuctionDTOBase {
  /** Id of auction */
  id: number;
  /** Current state of auction TODO Explanation */
  auctionState: AuctionState;
  /** Auction item with complete information */
  auctionItem: AuctionItemDTO;
  city?: string;
  email?: string;
  numberOfBids: number;
  numberOfBidders: number;
  negotiationMessages?: NegotiationMessageById;
  questions?: AuctionQuestionDTO[];
  /**
   * Deadline for the consumer to accept an offer
   * @format date-time
   */
  offerEndTime?: string;
  acceptedBidId?: number;
  /** Highest bid amount */
  highestBidAmount?: number;
  /**
   * Start time of auction
   * @format date-time
   */
  startTime?: string;
  /**
   * End time of auction
   * @format date-time
   */
  endTime?: string;
  /**
   * When auction was created
   * @format date-time
   */
  createdAt?: string;
  /**
   * When auction was modified
   * @format date-time
   */
  modifiedAt?: string;
  /**
   * When auction was marked sold
   * @format date-time
   */
  markedSoldAt?: string;
  /**
   * When the consumer used their one-time extend-negotiation action on this auction
   * @format date-time
   */
  extendedAt?: string;
  /** Additional information added after auction publication */
  auctionAdditionalInfo?: AuctionAdditionalInfoDTO[];
}

/** Admin specific Auction response */
export type AdminAuctionDTO = AuctionDTOBase & {
  bids: BidDTO[];
  /** Bid that is currently in the lead */
  highestBid?: BidDTO;
  /** Id of auction owner user */
  userId: number;
  /** User object with AdminAuctionDTO */
  user: AdminAuctionUser;
  /** Top 3 bidders in auction */
  topBidders: BidDTO[];
  audience: "admin";
  targetPriceReached: boolean;
};

/** Simplified VehicleDTO with necessary data to render table row */
export interface AdminAuctionTableRowVehicle {
  make: string;
  model: string;
  regNo: string;
  /** Type of vehicle i.e. car/moto/caravan (moto includes motorcycles, mopeds, scooters, ATVs, etc) */
  vehicleType?: VehicleType;
  /** Source of vehicle data (e.g. beely, organic, user, nettix, traficom, vertical imports) */
  source?: string;
}

/** Simplified AuctionDTO with necessary data to render table row */
export interface AdminAuctionTableRow {
  /** Id of auction */
  id: number;
  /** Current state of auction TODO Explanation */
  auctionState: AuctionState;
  /** Auction item vehicle information */
  auctionItem: {
    id: number;
    auctionItemDetails?: AuctionItemDetailsDTO;
    /** Simplified VehicleDTO with necessary data to render table row */
    vehicle?: AdminAuctionTableRowVehicle;
  };
  /** Id of auction owner user */
  userId: number;
  /** Email of a consumer user */
  email: string;
  numberOfBids: number;
  numberOfBidders: number;
  /** Does auction have any bids with negotiationMessages */
  hasNegotiationMessages: boolean;
  /** Does auction have any admin notes */
  hasAdminNotes: boolean;
  /**
   * Start time of auction
   * @format date-time
   */
  startTime?: string;
  /**
   * End time of auction
   * @format date-time
   */
  endTime?: string;
  /**
   * Deadline for the consumer to accept an offer
   * @format date-time
   */
  offerEndTime?: string;
  /** Highest bid amount */
  highestBidAmount?: number;
  /** Highest accepted bid amount */
  acceptedBidAmount?: number;
  /** Amounts of final offers submitted for this auction */
  finalOfferAmounts?: number[] | null;
  /** Whether a Kuntoraportti exists for this vehicle */
  hasKuntoraportti?: boolean;
  /** Does auction have any dealer questions */
  hasQuestions?: boolean;
}

/** User object with AdminAuctionDTO */
export interface AdminAuctionUser {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  address?: UserAddress;
}

/** Consumer specific Auction response */
export type ConsumerAuctionDTO = AuctionDTOBase & {
  /** Array of `OfferDTO`. Showed when fetching ENDED auction to consumer user */
  offers: OfferDTO[];
  /** True when the consumer can still use their one-time extend-negotiation action, i.e. the auction really is NOT_SOLD (not AWAITING_FINAL_OFFER, which is shown as NOT_SOLD), has not been extended yet, has offers to reopen and is within the extend-negotiation deadline */
  canExtendNegotiation: boolean;
  /**
   * Deadline for the extend-negotiation action — 2 days after the auction ended, moved to the next business day when it would land on a weekend or holiday. Only present while `canExtendNegotiation` is true
   * @format date-time
   */
  extendNegotiationDeadline?: string;
  /** Bid that won the auction and has been accepted by seller */
  acceptedOffer?: OfferDTO;
  targetPriceReached: boolean;
  audience: "consumer";
  /** Business DAC7 identity for business-owned auctions */
  dac7BusinessIdentity?: BusinessDac7Identity | null;
};

/** Dealer specific Auction response */
export type DealerAuctionDTO = AuctionDTOBase & {
  /** Highest bid by requester user */
  myHighestBid?: BidDTO;
  /** Highest bid by requester user's organization (own business or parent/child) */
  ourHighestBid?: BidDTO;
  /** Bid that is currently in the lead */
  highestBid?: BidDTO;
  /** Top 3 bidders in auction */
  topBidders?: BidDTO[];
  /** Distance between seller and business user in kilometers. Exists only if requester is business user and both have valid address */
  distanceBetween?: number;
  /** Closest business to seller based on business location. Can be different than user's linked business if user is linked to group level. */
  closestBusiness?: BaseBusinessDTO;
  /** Exists if user has bid machine used in auction */
  myBidMachine?: BidMachineDTO;
  /** Exists if user's organization has bid machines used in auction */
  ourBidMachines?: BidMachineDTO[];
  /** Own or company user's notes */
  notes?: NoteDTO[];
  /** Number of own or company user's notes left on other auctions of the same vehicle (matched by regNo), within the note history cutoff */
  noteHistoryCount?: number;
  audience: "dealer";
  /** Is auction marked as a favourite by user */
  isFavourite?: boolean;
  /** Is auction marked as hidden by user */
  isHidden?: boolean;
  /** Number of times this dealer has flagged this auction for admin review */
  myFlagCount?: number;
  /** Whether dealer can submit a final offer (only top1 bidder when auction is in AWAITING_FINAL_OFFER state) */
  canSubmitFinalOffer?: boolean;
  /** All businesses that bid on this auction, grouped by business. Only populated for top-1 bidder when auction state is ENDED. */
  competitors?: CompetitorDTO[];
  /** Seller contact information included when own bid has been accepted */
  sellerContactInfo?: {
    name: string;
    phoneNumber: string;
    email?: string;
    streetAddress?: string;
    city: string;
  };
};

/** A competing business in an auction with their highest bid */
export interface CompetitorDTO {
  /** Marketing name of the business */
  businessName: string;
  /** Highest bid amount placed by this business */
  highestBidAmount: number;
  /** Database ID of the business */
  businessId: number;
}

export type AuctionDTO =
  | AdminAuctionDTO
  | ConsumerAuctionDTO
  | DealerAuctionDTO;

export type NegotiationMessageById = Record<string, NegotiationMessageDTO[]>;

/** Current state of auction TODO Explanation */
export enum AuctionState {
  DRAFT = "DRAFT",
  STARTED = "STARTED",
  ENDED = "ENDED",
  OFFER_ACCEPTED = "OFFER_ACCEPTED",
  SOLD = "SOLD",
  SENT_FOR_BILLING = "SENT_FOR_BILLING",
  BILLED = "BILLED",
  NOT_SOLD = "NOT_SOLD",
  REJECTED_BY_DEALER = "REJECTED_BY_DEALER",
  CANCELLED = "CANCELLED",
  DELETED = "DELETED",
  AWAITING_FINAL_OFFER = "AWAITING_FINAL_OFFER"
}

export interface CreateBidBody {
  bid: {
    /** Bidded amount */
    amount: number;
    /** Used currency */
    currency?: string;
    /** If bid includes pickup from buyer */
    pickupIncluded: boolean;
  };
  bidMachine?: CreateBidMachine;
}

export interface UpdateBidBody {
  /** Updated offer amount from dealer user */
  amount: number;
  /** Current state of auction TODO Explanation */
  auctionState?: AuctionState;
  /** Reason why dealer lowered their price in face to face situation */
  updateReason?: string | null;
  updateType?: "BID_UPDATED" | "BID_UPDATED_AND_STATE_CHANGE";
}

/** Body when creating bid machine to cover existing bid */
export interface CreateBidMachineBody {
  bidId: number;
  bidMachine: CreateBidMachine;
}

export interface CreateBidMachine {
  /** Max amount machine is allowed to bid */
  maxAmount: number;
  /** Guaranteed amount for bid machine to cover existing bid */
  guaranteedAmount?: number | null;
  /** If bid includes pickup from buyer */
  pickupIncluded: boolean;
  /** Used currency */
  currency?: string;
}

export enum BidState {
  OK = "OK",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  WITHDRAWN = "WITHDRAWN",
  IN_NEGOTIATION = "IN_NEGOTIATION"
}

/** Reduced Bid object with relevant data */
export interface BidDTO {
  /** Bid id */
  id: number;
  /** Id of user that created the Bid */
  userId: number;
  /** Bidded amount */
  amount: number;
  /** Exists if bid was done by bid machine */
  bidMachineId?: number;
  /** Used currency */
  currency: string;
  /** If bid includes pickup from buyer */
  pickupIncluded?: boolean | null;
  state: BidState;
  /**
   * When bid was created
   * @format date-time
   */
  createdAt: string;
  /** Bid rank, 1 is in the lead. */
  rank: number;
  /** Bid user details. Exists only in `ourHighestBid` or `AdminAuctionDTO`'s topBidders to determine who from user's organization has placed bid */
  user?: BidUser;
  /** Reason why bid owner withdrew its offer. Visible only to dealer's own bid and admin users */
  withdrawReason?: string;
  /** Reason why dealer lowered their price in face to face situation */
  updateReason?: string;
}

/** Bid user details */
export interface BidUser {
  firstName: string;
  lastName: string;
  email: string;
  /** Name of business user is linked to */
  businessName: string;
}

/** Reduced Bid object with relevant data for consumer to either accept, decline or start negotiation with */
export interface OfferDTO {
  /** Bid id */
  id: number;
  /** Bidded amount */
  amount: number;
  /** Used currency */
  currency: string;
  /** If bid includes pickup from buyer */
  pickupIncluded?: boolean | null;
  /** Distance between seller and bid owner */
  distanceBetween?: number;
  /** City of dealer business */
  city: string;
  state: BidState;
  /**
   * When bid was created
   * @format date-time
   */
  createdAt: string;
  /** name of closest business of bidder's organization */
  businessName: string;
  /** Original bid rank after auction has ended and no offers declined */
  originalOfferRank?: number | null;
  /** Reason for bid update (e.g., FINAL_OFFER) */
  updateReason?: string | null;
}

export interface UpdateBidMachineBody {
  /** Max amount machine is allowed to bid */
  maxAmount?: number;
  /** Guaranteed amount for bid machine to cover existing bid */
  guaranteedAmount?: number | null;
  /** If bid includes pickup from buyer */
  pickupIncluded?: boolean;
  /** Used currency */
  currency?: string;
  /** Is bid machine active */
  isActive?: boolean;
}

export interface BidMachineDTO {
  /** Bid machine Id */
  id: number;
  /** Id of user that created the Bid machine */
  userId: number;
  /** Id of auction machine will do bidding to */
  auctionId: number;
  /** Max amount machine is allowed to bid */
  maxAmount: number;
  /** Guaranteed amount for bid machine to cover existing bid */
  guaranteedAmount?: number | null;
  /** Is bid machine currently active */
  isActive: boolean;
  /** Used currency */
  currency?: string;
  /**
   * When auction was created
   * @format date-time
   */
  createdAt: string;
  /**
   * When auction was modified
   * @format date-time
   */
  modifiedAt: string;
}

/** Additional details of auction item to update auction item entity */
export interface UpdateAuctionItem {
  /** Combined auction item state listing covering all vehicle types */
  itemState: AuctionItemState;
  auctionItemDetails?: AuctionItemDetailsDTO;
  media?: AuctionItemMediaDTO[];
}

export interface AuctionItemDetailsDTO {
  /** Vehicle mileage */
  mileage?: number;
  /** Mileage unit */
  mileageUnit?: MileageUnit;
  /** Is vehicle VAT deductible */
  vatDeductible?: boolean;
  /** Price user would be willing to sell vehicle for */
  targetPrice?: number;
  /** Ownership of vehicle */
  ownership?: VehicleOwnership;
  /** How many keys come with the vehicle */
  keyCount?: number;
  /** State of maintenance book */
  maintenanceBook?: MaintenanceBook;
  /** Additional details about incomplete maintenance book */
  maintenanceBookInfo?: string;
  lastMaintenance?: LastMaintenance;
  inspectionInfo?: InspectionInfo;
  /** Estimate of the going price for the vehicle */
  priceEstimate?: number | null;
  /**
   * Mittaristo reliability score stored alongside the estimate
   * @min 0
   * @max 3
   */
  priceEstimateReliabilityIndicator?: number | null;
  tiresInfo?: {
    summer?: TireInfo;
    winter?: TireInfo;
  };
  windshieldInfo?: {
    /** Condition of windshield */
    condition?: WindshieldCondition;
    /** Additional info */
    freeText?: string;
    /** Windshield insurance */
    insurance?: boolean;
  };
  damageInfo?: {
    extent?: (DamageExtent | DamageExtentMoto | DamageExtentCaravan)[];
    /** Additional info */
    freeText?: string;
    /** Whether the vehicle has been smoked in */
    smokedIn?: boolean | null;
  };
  moistureMeasurement?: {
    /** Whether moisture measurement was performed */
    performed?: boolean;
    /** Month when moisture measurement was performed (1-12) */
    month?: number;
    /** Year when moisture measurement was performed */
    year?: number;
  };
  accessoryInfo?: {
    /** e.g Classic, Elegance, Business Premium... */
    accessoryName?: string;
    /** List of accessories. Typed as string[] due to complications with API Gateway validation. */
    accessories?: string[];
    /** Accessories entered as free text */
    freeText?: string;
  };
  freeDescription?: string;
  delivery?: {
    /** How vehicle will be delivered to buyer */
    method?: DeliveryMethod;
    /** How far away is seller ready to deliver the vehicle (in km) */
    range?: number;
  };
  timingSystemInfo?: {
    /** Timing system of vehicle */
    timingSystem?: TimingSystem;
    /** mileage */
    mileage?: number;
    /** Month when timing system was changed (1-12) */
    month?: number;
    /** Year when timing system was changed */
    year?: number;
  };
  /** Duration in business days for the auction (1 or 2) */
  auctionDuration?: number;
}

/** Hosting service the media is uploaded to */
export enum MediaService {
  AISAV1 = "AISA_V1",
  AISAV2 = "AISA_V2"
}

/** Media linked to AuctionItem (image, video, etc) */
export interface AuctionItemMediaDTO {
  /** S3 key for media */
  key: string;
  /** Where media is taken from (Front, Back, Side, Trunk etc) */
  from: string;
  /** Hosting service the media is uploaded to */
  mediaService?: MediaService;
}

/** Request body for the update auction item endpoint */
export interface UpdateAuctionItemBody {
  /** Combined auction item state listing covering all vehicle types */
  itemState: AuctionItemState;
  auctionItemDetails?: AuctionItemDetailsDTO;
  media?: AuctionItemMediaDTO[];
  /** Whether to attach the A-Katsastus Kuntoraportti to this listing */
  includeKuntoraportti?: boolean;
  /**
   * A-Katsastus inspection UUID to attach as Kuntoraportti
   * @format uuid
   */
  kuntoraporttiInspectionId?: string;
}

export type AuctionItemDTO = UpdateAuctionItem & {
  id?: number;
  /** Static vehicle data from third party source (Trafi) */
  vehicle?: VehicleDTO;
  /** S3 object key for the Kuntoraportti PDF (present when attached to the listing) */
  kuntoraporttiKey?: string;
  /**
   * A-Katsastus inspection UUID available for this vehicle (present when a Kuntoraportti exists for the vehicle's regNo, regardless of whether the seller opted in)
   * @format uuid
   */
  kuntoraporttiInspectionId?: string;
};

/** Combined auction item state listing covering all vehicle types */
export enum AuctionItemState {
  STEP_REGNO_AND_MILEAGE = "STEP_REGNO_AND_MILEAGE",
  STEP_BASIC_CAR_INFORMATION = "STEP_BASIC_CAR_INFORMATION",
  STEP_BASIC_INFORMATION = "STEP_BASIC_INFORMATION",
  STEP_VEHICLE_CONDITION = "STEP_VEHICLE_CONDITION",
  STEP_DAMAGES = "STEP_DAMAGES",
  STEP_ACCESSORIES = "STEP_ACCESSORIES",
  STEP_MEDIA = "STEP_MEDIA",
  STEP_FREE_DESCRIPTION = "STEP_FREE_DESCRIPTION",
  STEP_DELIVERY = "STEP_DELIVERY",
  STEP_PRICE_ESTIMATE = "STEP_PRICE_ESTIMATE",
  STEP_SUMMARY = "STEP_SUMMARY",
  FINISHED = "FINISHED",
  MOTO_STEP_REGNO_AND_MILEAGE = "MOTO_STEP_REGNO_AND_MILEAGE",
  MOTO_STEP_BASIC_VEHICLE_INFORMATION = "MOTO_STEP_BASIC_VEHICLE_INFORMATION",
  MOTO_STEP_TECHNICAL_INFORMATION = "MOTO_STEP_TECHNICAL_INFORMATION",
  MOTO_STEP_BASIC_INFORMATION = "MOTO_STEP_BASIC_INFORMATION",
  MOTO_STEP_VEHICLE_CONDITION = "MOTO_STEP_VEHICLE_CONDITION",
  MOTO_STEP_ACCESSORIES = "MOTO_STEP_ACCESSORIES",
  MOTO_STEP_MEDIA = "MOTO_STEP_MEDIA",
  MOTO_STEP_FREE_DESCRIPTION = "MOTO_STEP_FREE_DESCRIPTION",
  MOTO_STEP_CONTACT_DELIVERY_PRICE = "MOTO_STEP_CONTACT_DELIVERY_PRICE",
  MOTO_STEP_SUMMARY = "MOTO_STEP_SUMMARY"
}

/** Current state of auction item. Either step of form or Finished. */
export enum CarAuctionItemState {
  STEP_REGNO_AND_MILEAGE = "STEP_REGNO_AND_MILEAGE",
  STEP_BASIC_CAR_INFORMATION = "STEP_BASIC_CAR_INFORMATION",
  STEP_BASIC_INFORMATION = "STEP_BASIC_INFORMATION",
  STEP_VEHICLE_CONDITION = "STEP_VEHICLE_CONDITION",
  STEP_DAMAGES = "STEP_DAMAGES",
  STEP_ACCESSORIES = "STEP_ACCESSORIES",
  STEP_MEDIA = "STEP_MEDIA",
  STEP_FREE_DESCRIPTION = "STEP_FREE_DESCRIPTION",
  STEP_DELIVERY = "STEP_DELIVERY",
  STEP_PRICE_ESTIMATE = "STEP_PRICE_ESTIMATE",
  STEP_SUMMARY = "STEP_SUMMARY",
  FINISHED = "FINISHED"
}

/** Current state of auction item. Either step of form or Finished. */
export enum MotoAuctionItemState {
  MOTO_STEP_REGNO_AND_MILEAGE = "MOTO_STEP_REGNO_AND_MILEAGE",
  MOTO_STEP_BASIC_VEHICLE_INFORMATION = "MOTO_STEP_BASIC_VEHICLE_INFORMATION",
  MOTO_STEP_TECHNICAL_INFORMATION = "MOTO_STEP_TECHNICAL_INFORMATION",
  MOTO_STEP_BASIC_INFORMATION = "MOTO_STEP_BASIC_INFORMATION",
  MOTO_STEP_VEHICLE_CONDITION = "MOTO_STEP_VEHICLE_CONDITION",
  MOTO_STEP_ACCESSORIES = "MOTO_STEP_ACCESSORIES",
  MOTO_STEP_MEDIA = "MOTO_STEP_MEDIA",
  MOTO_STEP_FREE_DESCRIPTION = "MOTO_STEP_FREE_DESCRIPTION",
  MOTO_STEP_CONTACT_DELIVERY_PRICE = "MOTO_STEP_CONTACT_DELIVERY_PRICE",
  MOTO_STEP_SUMMARY = "MOTO_STEP_SUMMARY",
  FINISHED = "FINISHED"
}

/** Type of vehicle i.e. car/moto/caravan (moto includes motorcycles, mopeds, scooters, ATVs, etc) */
export enum VehicleType {
  CAR = "CAR",
  MOTO = "MOTO",
  CARAVAN = "CARAVAN"
}

/** Vertical marketplace source (nettiauto, nettimoto, or nettikaravaani) */
export enum VerticalSource {
  Nettiauto = "nettiauto",
  Nettimoto = "nettimoto",
  Nettikaravaani = "nettikaravaani"
}

/** Static vehicle data from third party source (Trafi) */
export interface VehicleDTO {
  /** Type of vehicle i.e. car/moto/caravan (moto includes motorcycles, mopeds, scooters, ATVs, etc) */
  vehicleType: VehicleType;
  bodyType?: string;
  bikeType?: string;
  color?: string;
  doorsCount?: number;
  driveType: string;
  engineSize?: number;
  engineType?: string;
  firstRegistrationYear?: number;
  firstRegistrationMonth?: number;
  fuelType?: string;
  gearType?: string;
  inspectionDate?: string;
  make: string;
  model: string;
  modelType?: string;
  modelTypeName?: string;
  modelYear?: number;
  personsCount?: number;
  power?: number;
  batteryCapacity?: number;
  powerClass?: string;
  regNo: string;
  ownerCount?: number;
  roadLegal?: boolean;
  coolingSystem?: string;
  trackWidth?: number;
  isSideBySide?: boolean;
  modelId?: number;
  makeId?: number;
  vehicleTypeId?: number;
  bodyTypeId?: number;
  bikeTypeId?: number;
  modelTypeId?: number;
  /** List of vehicle accessories */
  accessories?: VehicleAccessory[];
  /** Vehicle identification number */
  vin?: string;
  /** Source of vehicle data (e.g. beely, organic, user, nettix, traficom, vertical imports) */
  source?: string;
}

/** Schema of response object returned from /vehicles/basicInfo */
export interface VehicleBasicInfo {
  /** Static vehicle data from third party source (Trafi) */
  vehicle?: VehicleDTO;
  contactInfo?: {
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    email?: string;
    streetAddress?: string;
    postalCode?: string;
    city?: string;
    country?: string;
  };
  kuntoraportti?: {
    /** Whether a Kuntoraportti exists for this vehicle */
    hasKuntoraportti: boolean;
    /**
     * A-Katsastus inspection UUID
     * @format uuid
     */
    inspectionId?: string;
  };
}

/** How vehicle will be delivered to buyer */
export enum DeliveryMethod {
  DELIVER = "DELIVER",
  PICKUP = "PICKUP"
}

/** Extent of damage on vehicle */
export enum DamageExtent {
  PAINT = "PAINT",
  SCRATCH = "SCRATCH",
  CRACK = "CRACK",
  DENT = "DENT",
  FAULT_LIGHT = "FAULT_LIGHT",
  AIR_CONDITIONING = "AIR_CONDITIONING"
}

/** Type of damage in the motorcycle */
export enum DamageExtentMoto {
  ENGINE = "ENGINE",
  FUEL_SYSTEM = "FUEL_SYSTEM",
  ELECTRICAL_SYSTEM = "ELECTRICAL_SYSTEM",
  TRANSMISSION_AND_CLUTCH = "TRANSMISSION_AND_CLUTCH",
  BRAKES = "BRAKES",
  TIRES_AND_SUSPENSION = "TIRES_AND_SUSPENSION",
  STEERING = "STEERING",
  EXHAUST = "EXHAUST",
  FAIRINGS = "FAIRINGS",
  TRACK = "TRACK",
  SUSPENSION_AND_CHASSIS = "SUSPENSION_AND_CHASSIS",
  COLD_START_PROBLEMS = "COLD_START_PROBLEMS",
  FRAME = "FRAME"
}

/** Type of damage in the caravan */
export enum DamageExtentCaravan {
  UPHOLSTERY = "UPHOLSTERY",
  MOISTURE_DAMAGE = "MOISTURE_DAMAGE"
}

/** Type of accessory in the vehicle */
export enum CarAccessory {
  POWER_STEERING = "POWER_STEERING",
  POWER_WINDOWS = "POWER_WINDOWS",
  TOW_BAR = "TOW_BAR",
  ALLOY_WHEELS = "ALLOY_WHEELS",
  TWO_SETS_OF_TYRES = "TWO_SETS_OF_TYRES",
  AIR_CONDITIONING_MANUAL = "AIR_CONDITIONING_MANUAL",
  AIR_CONDITIONING_AUTOMATIC = "AIR_CONDITIONING_AUTOMATIC",
  INTERIOR_SOCKET = "INTERIOR_SOCKET",
  MOTOR_HEATER = "MOTOR_HEATER",
  LEATHER_UPHOLSTERY = "LEATHER_UPHOLSTERY",
  ABS_BRAKES = "ABS_BRAKES",
  AIRBAG = "AIRBAG",
  HUOLTOKIRJA_PAPER = "HUOLTOKIRJA_PAPER",
  HUOLTOKIRJA_ELECTRONIC = "HUOLTOKIRJA_ELECTRONIC",
  SOUND_SYSTEM = "SOUND_SYSTEM",
  IMMOBILIZER = "IMMOBILIZER",
  ALARM_SYSTEM = "ALARM_SYSTEM",
  SUNROOF_WITHOUT_PANORAMA = "SUNROOF_WITHOUT_PANORAMA",
  SUNROOF_WITH_PANORAMA = "SUNROOF_WITH_PANORAMA",
  TRACTION_CONTROL = "TRACTION_CONTROL",
  CRUISE_CONTROL_TRADITIONAL = "CRUISE_CONTROL_TRADITIONAL",
  CRUISE_CONTROL_ADAPTIVE = "CRUISE_CONTROL_ADAPTIVE",
  FUEL_BATTERY_HEATER = "FUEL_BATTERY_HEATER",
  ELECTRIC_SEATS_WITHOUT_MEMORY = "ELECTRIC_SEATS_WITHOUT_MEMORY",
  ELECTRIC_SEATS_WITH_MEMORY = "ELECTRIC_SEATS_WITH_MEMORY",
  ON_BOARD_COMPUTER = "ON_BOARD_COMPUTER",
  XENON_LIGHT = "XENON_LIGHT",
  SEAT_HEATERS = "SEAT_HEATERS",
  PARKING_SENSORS = "PARKING_SENSORS",
  ELECTRIC_MIRRORS = "ELECTRIC_MIRRORS",
  SATELLITE_NAVIGATOR = "SATELLITE_NAVIGATOR",
  DRIVING_ASSISTANT = "DRIVING_ASSISTANT",
  SUSPENSION_KIT = "SUSPENSION_KIT",
  FOG_LIGHTS = "FOG_LIGHTS",
  TURBO = "TURBO",
  ROOF_OPENING_ELECTRONIC = "ROOF_OPENING_ELECTRONIC",
  ROOF_OPENING_MANUAL = "ROOF_OPENING_MANUAL",
  ACCESSORIES_FOR_INVALIDS = "ACCESSORIES_FOR_INVALIDS",
  RAIN_SENSOR = "RAIN_SENSOR",
  MULTIACTIVE_STEERING_WHEEL = "MULTIACTIVE_STEERING_WHEEL",
  AUDIO_INPUT = "AUDIO_INPUT",
  HANDS_FREE_KIT = "HANDS_FREE_KIT",
  SPORT_BASE = "SPORT_BASE",
  SUNROOF = "SUNROOF",
  ISOFIX_READY = "ISOFIX_READY",
  CURVE_LIGHTS = "CURVE_LIGHTS",
  AUTO_HOLD = "AUTO_HOLD",
  KEYLESS_START = "KEYLESS_START",
  HEATED_WINDSHIELD = "HEATED_WINDSHIELD",
  SKI_HATCH = "SKI_HATCH",
  ELECTRIC_TAILGATE = "ELECTRIC_TAILGATE",
  CARGO_SAFETY_NET = "CARGO_SAFETY_NET",
  LED_HEADLIGHTS = "LED_HEADLIGHTS",
  SPORT_SEATS = "SPORT_SEATS",
  PARKING_ASSISTANT = "PARKING_ASSISTANT",
  REVERSING_CAMERA_SIMPLE = "REVERSING_CAMERA_SIMPLE",
  REVERSINGCAMERA360 = "REVERSING_CAMERA_360",
  HYBRID_PLUGIN_CHARGING = "HYBRID_PLUGIN_CHARGING",
  AIR_SUSPENSION = "AIR_SUSPENSION",
  START_STOP_SYSTEM = "START_STOP_SYSTEM",
  TIRE_PRESSURE_MONITORING = "TIRE_PRESSURE_MONITORING",
  TRAFFIC_SIGN_RECOGNITION = "TRAFFIC_SIGN_RECOGNITION",
  LANE_DEPARTURE_WARNING = "LANE_DEPARTURE_WARNING",
  HEAD_UP_DISPLAY = "HEAD_UP_DISPLAY",
  SMARTPHONE_INTEGRATION = "SMARTPHONE_INTEGRATION",
  ADAPTIVE_HEADLIGHTS = "ADAPTIVE_HEADLIGHTS",
  EMERGENCY_BRAKE_ASSIST = "EMERGENCY_BRAKE_ASSIST",
  COLLISION_AVOIDANCE = "COLLISION_AVOIDANCE",
  TRUNK_TEMP_CONTROL = "TRUNK_TEMP_CONTROL",
  BLIND_SPOT_SENSOR = "BLIND_SPOT_SENSOR",
  HEATED_STEERING_WHEEL = "HEATED_STEERING_WHEEL",
  FOLDING_REAR_SEATS = "FOLDING_REAR_SEATS",
  BATTERY_PREHEATING = "BATTERY_PREHEATING",
  USB = "USB",
  BLUETOOTH = "BLUETOOTH",
  AIR_CONDITIONED_SEATS = "AIR_CONDITIONED_SEATS",
  CENTRAL_LOCKING_KEYLESS = "CENTRAL_LOCKING_KEYLESS",
  CENTRAL_LOCKING_REMOTE = "CENTRAL_LOCKING_REMOTE",
  CENTRAL_LOCKING_WITH_KEY = "CENTRAL_LOCKING_WITH_KEY"
}

/** Type of accessory in the motorcycle */
export enum MotorcycleAccessory {
  OUTLET12V = "OUTLET_12V",
  SERVICE_BOOK = "SERVICE_BOOK",
  CRASH_BARS = "CRASH_BARS",
  HEATED_GRIPS = "HEATED_GRIPS",
  TRACTION_CONTROL = "TRACTION_CONTROL",
  ANTI_LOCK_BRAKES = "ANTI_LOCK_BRAKES",
  NAVIGATOR = "NAVIGATOR",
  BACKREST = "BACKREST",
  SIDE_BAGS = "SIDE_BAGS",
  ELECTRIC_START = "ELECTRIC_START",
  TOP_CASE = "TOP_CASE",
  CRUISE_CONTROL = "CRUISE_CONTROL",
  ADAPTIVE_CRUISE_CONTROL = "ADAPTIVE_CRUISE_CONTROL"
}

/** Type of accessory in the ATV */
export enum ATVAccessory {
  STORAGE_BOXES = "STORAGE_BOXES",
  WINCH = "WINCH",
  SNOW_PLOW = "SNOW_PLOW",
  SKID_PLATE = "SKID_PLATE",
  OFF_ROAD_TIRES = "OFF_ROAD_TIRES",
  LED_LIGHTS = "LED_LIGHTS",
  TOW_HITCH = "TOW_HITCH"
}

/** Type of accessory in the moped */
export enum MopedAccessory {
  LUGGAGE_RACK = "LUGGAGE_RACK",
  SMALL_TOP_CASE = "SMALL_TOP_CASE",
  CHAIN_GUARD = "CHAIN_GUARD",
  HEATED_GRIPS = "HEATED_GRIPS",
  USB_CHARGING_PORT = "USB_CHARGING_PORT",
  LED_LIGHTS = "LED_LIGHTS",
  SEAT_COVER = "SEAT_COVER",
  FOOT_GUARDS = "FOOT_GUARDS"
}

/** Type of accessory in the scooter */
export enum ScooterAccessory {
  SEAT_BAG = "SEAT_BAG",
  TOP_CASE = "TOP_CASE",
  MIRRORS = "MIRRORS",
  WEATHER_SHIELD = "WEATHER_SHIELD",
  HAND_GUARDS = "HAND_GUARDS",
  USB_CHARGING_PORT = "USB_CHARGING_PORT",
  LED_LIGHTS = "LED_LIGHTS",
  PHONE_MOUNT = "PHONE_MOUNT"
}

/** Type of accessory in the snowmobile */
export enum SnowmobileAccessory {
  STORAGE_BAGS = "STORAGE_BAGS",
  CARGO_RACKS = "CARGO_RACKS",
  HEATED_GRIPS = "HEATED_GRIPS",
  LED_HEADLIGHTS = "LED_HEADLIGHTS",
  GPS_NAVIGATOR = "GPS_NAVIGATOR",
  SKID_PLATE = "SKID_PLATE",
  DEEP_SNOW_TRACKS = "DEEP_SNOW_TRACKS",
  SNOW_ANCHORS = "SNOW_ANCHORS"
}

/** Type of accessory in the moped car */
export enum MopedCarAccessory {
  CENTRAL_LOCKING = "CENTRAL_LOCKING",
  LEATHER_INTERIOR = "LEATHER_INTERIOR",
  BACK_SEAT = "BACK_SEAT",
  RADIO = "RADIO",
  ELECTRIC_WINDOWS = "ELECTRIC_WINDOWS",
  REVERSING_CAMERA = "REVERSING_CAMERA",
  USB_CHARGING_PORT = "USB_CHARGING_PORT",
  LED_DAYTIME_RUNNING_LIGHTS = "LED_DAYTIME_RUNNING_LIGHTS"
}

/** Type of accessory in the caravan */
export enum CaravanAccessory {
  AIR_CONDITIONING_LIVING_AREA = "AIR_CONDITIONING_LIVING_AREA",
  GAS_STOVE = "GAS_STOVE",
  BUNK_BED = "BUNK_BED",
  AWNING = "AWNING",
  DOUBLE_BED = "DOUBLE_BED",
  SEPARATE_BEDS = "SEPARATE_BEDS",
  FRIDGE = "FRIDGE",
  ALDE_HEATING = "ALDE_HEATING",
  TRUMATIC_HEATING = "TRUMATIC_HEATING",
  SOLAR_PANELS = "SOLAR_PANELS",
  INSULATED_GREY_WATER = "INSULATED_GREY_WATER",
  FLOOR_HEATING = "FLOOR_HEATING",
  BIKE_RACK = "BIKE_RACK",
  MAINS_ELECTRIC_HEATING = "MAINS_ELECTRIC_HEATING",
  CABIN_AC = "CABIN_AC",
  CASSETTE_WC = "CASSETTE_WC",
  CASSETTE_CURTAINS = "CASSETTE_CURTAINS",
  CARPETS_IN_BACK = "CARPETS_IN_BACK",
  CENTRAL_HEATING = "CENTRAL_HEATING",
  FREEZER = "FREEZER",
  HOT_WATER_TANK = "HOT_WATER_TANK",
  MICROWAVE_OVEN = "MICROWAVE_OVEN",
  REAR_KITCHEN = "REAR_KITCHEN",
  SHOWER = "SHOWER",
  SINK = "SINK",
  ELECTRIC_STEP = "ELECTRIC_STEP",
  STABILIZER = "STABILIZER",
  SUN_ROOF = "SUN_ROOF",
  TV_ANTENNA_OR_SATELLITE_DISH = "TV_ANTENNA_OR_SATELLITE_DISH",
  FUEL_HEATER = "FUEL_HEATER",
  GENERATOR = "GENERATOR",
  ROOF_BOX = "ROOF_BOX",
  DOUBLE_BOTTOM = "DOUBLE_BOTTOM",
  FRONT_CANOPY = "FRONT_CANOPY",
  FRONT_TENT = "FRONT_TENT",
  SERVICE_MANUAL = "SERVICE_MANUAL",
  ISLAND_BED = "ISLAND_BED",
  DROP_DOWN_BED = "DROP_DOWN_BED"
}

/** Combined accessory listing covering all vehicle types */
export type VehicleAccessory =
  | CarAccessory
  | MotorcycleAccessory
  | ATVAccessory
  | MopedAccessory
  | MopedCarAccessory
  | ScooterAccessory
  | SnowmobileAccessory
  | CaravanAccessory;

/** Condition of windshield */
export enum WindshieldCondition {
  GOOD = "GOOD",
  WORN_OUT = "WORN_OUT",
  STONE_MARK = "STONE_MARK",
  CRACKED = "CRACKED"
}

export interface TireInfo {
  /** Wear of tires */
  wear?: TireWear;
  rims?: boolean;
}

/** Wear of tires */
export enum TireWear {
  NEW = "NEW",
  GOOD = "GOOD",
  FAIR = "FAIR",
  BAD = "BAD",
  NONE = "NONE"
}

/** Status of inspection information */
export enum InspectionStatus {
  UNKNOWN = "UNKNOWN",
  NOT_INSPECTED = "NOT_INSPECTED"
}

export interface InspectionInfo {
  /** Year of the last vehicle inspection */
  year?: number;
  /** Month of the last vehicle inspection (1-12) */
  month?: number;
  /** Status of inspection information */
  status?: InspectionStatus;
}

export interface LastMaintenance {
  year: number;
  month: number;
  mileage: number;
}

/** State of maintenance book */
export enum MaintenanceBook {
  PERFECT_BRAND = "PERFECT_BRAND",
  PERFECT = "PERFECT",
  MAINTAINED_NOT_BY_PROGRAM = "MAINTAINED_NOT_BY_PROGRAM",
  INCOMPLETE = "INCOMPLETE",
  NONE = "NONE"
}

/** Mileage unit */
export enum MileageUnit {
  KM = "KM",
  H = "H"
}

/** Ownership of vehicle */
export enum VehicleOwnership {
  SELF = "SELF",
  OTHER = "OTHER",
  FINANCE_COMPANY = "FINANCE_COMPANY",
  BUSINESS = "BUSINESS"
}

/** Timing system of vehicle */
export enum TimingSystem {
  BELT_ORIGINAL = "BELT_ORIGINAL",
  BELT_CHANGED = "BELT_CHANGED",
  CHAIN_ORIGINAL = "CHAIN_ORIGINAL",
  CHAIN_CHANGED = "CHAIN_CHANGED",
  UNKNOWN = "UNKNOWN"
}

/** Type of user action on an auction */
export enum UserActionType {
  FAVOURITE = "FAVOURITE",
  HIDDEN = "HIDDEN"
}

/** User action on an auction (favourite or hide) */
export interface UserActionDTO {
  /** Unique identifier for the user action */
  id: number;
  /** ID of the user who performed the action */
  userId: number;
  /** ID of the auction the action was performed on */
  auctionId: number;
  /** Type of action performed */
  action: UserActionType;
  /**
   * When the action was created
   * @format date-time
   */
  createdAt: string;
}

/** Error response */
export interface ErrorResponse {
  /** Error message */
  message?: string;
}

/** DAC7 compliance status of user, i.e. do we have all personal details we are required to collect. Only applicable to sellers. */
export enum Dac7Status {
  COMPLIANT = "COMPLIANT",
  NON_COMPLIANT = "NON_COMPLIANT",
  NON_COMPLIANT_FIRST_EMAIL_SENT = "NON_COMPLIANT_FIRST_EMAIL_SENT",
  NON_COMPLIANT_SECOND_EMAIL_SENT = "NON_COMPLIANT_SECOND_EMAIL_SENT",
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  NOT_APPLICABLE = "NOT_APPLICABLE"
}

export interface UserDTO {
  /** User Id. Same as Alma-tunnus Id */
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  businessId?: number | null;
  /** Baana user role */
  role: UserRole;
  preferences?: UserPreferences;
  address?: UserAddress;
  /** BaseBusinessDTO with relational data (parent-child) */
  business?: BusinessDTO;
  /**
   * When user was created
   * @format date-time
   */
  createdAt?: string;
  /**
   * When user was modified
   * @format date-time
   */
  modifiedAt?: string;
  /** True if user's email is verified with Alma-tunnus */
  emailVerified: boolean;
  /** User's tax identification number / personal identity code */
  taxIdentificationNumber?: string;
  /** DAC7 compliance status of user, i.e. do we have all personal details we are required to collect. Only applicable to sellers. */
  dac7Status?: Dac7Status;
}

/** Baana user role */
export enum UserRole {
  Consumer = "consumer",
  Dealer = "dealer",
  DealerAdmin = "dealerAdmin",
  Admin = "admin"
}

export interface UserAddress {
  streetAddress?: string;
  postalCode: string;
  city: string;
  country?: string;
}

export interface UserContactInfo {
  address: UserAddress;
  phoneNumber: string;
  taxIdentificationNumber?: string;
}

/** Client-provided fields for creating or updating a business DAC7 identity. Server-managed fields (createdAt, modifiedAt) are excluded. */
export interface BusinessDac7IdentityRequest {
  /** @minLength 1 */
  businessRegistryNumber: string;
  /**
   * @default "FI"
   * @pattern ^[A-Z]{2}$
   */
  tinIssuingCountry?: string;
  vatNumber?: string | null;
  /** @minLength 1 */
  officialName: string;
  /**
   * @default "FI"
   * @pattern ^[A-Z]{2}$
   */
  resCountryCode?: string;
  /** @minLength 1 */
  addressStreet: string;
  /** @minLength 1 */
  addressPostalCode: string;
  /** @minLength 1 */
  addressCity: string;
}

export interface BusinessDac7Identity {
  /** @minLength 1 */
  businessRegistryNumber: string;
  /**
   * @default "FI"
   * @pattern ^[A-Z]{2}$
   */
  tinIssuingCountry?: string;
  vatNumber?: string | null;
  /** @minLength 1 */
  officialName: string;
  /**
   * @default "FI"
   * @pattern ^[A-Z]{2}$
   */
  resCountryCode?: string;
  /** @minLength 1 */
  addressStreet: string;
  /** @minLength 1 */
  addressPostalCode: string;
  /** @minLength 1 */
  addressCity: string;
  /**
   * When the identity record was created
   * @format date-time
   */
  createdAt?: string;
  /**
   * When the identity record was last modified
   * @format date-time
   */
  modifiedAt?: string;
}

export interface UpdateUserContactInfo {
  address?: UserAddress;
  phoneNumber?: string | null;
  taxIdentificationNumber?: string;
}

export interface UpdateUserRequestBody {
  contactInfo: UpdateUserContactInfo;
  preferences: UserPreferences;
}

/** BusinessDTO without relation data (parent-child) */
export interface BaseBusinessDTO {
  /** DB Id for Business */
  id: number;
  /** Parent Id for Business (references businessId) */
  parentSalesforceId?: string | null;
  /** Salesforce Id of Business */
  salesforceId?: string | null;
  /** Y-Tunnus of Business */
  yTunnus?: string | null;
  name: string;
  marketingName?: string | null;
  email?: string | null;
  streetAddress?: string | null;
  postalCode?: string | null;
  city?: string | null;
  country?: string | null;
}

/** BaseBusinessDTO with relational data (parent-child) */
export type BusinessDTO = BaseBusinessDTO & {
  /** BaseBusinessDTO with relational data (parent-child) */
  parentBusiness?: BusinessDTO | null;
  childBusinesses?: BusinessDTO[];
};

/** Business */
export type ListBusinessDTO = BaseBusinessDTO & {
  users: UserDTO[];
};

export interface VehiclePriceEstimate {
  /** Bottom price estimate from Netwheels Mittaristo (absent when suppressed) */
  priceBottomEstimate?: number | null;
  /**
   * Mittaristo reliability score (0–3); absent on transport error
   * @min 0
   * @max 3
   */
  reliabilityIndicator?: number | null;
}

/** Configuration paremeter key to store to DB */
export enum ConfigurationParameterKey {
  AUCTION_DURATION_DAYS = "AUCTION_DURATION_DAYS",
  AUCTION_BID_EXTEND_TIME = "AUCTION_BID_EXTEND_TIME",
  BUSINESS_HOURS_START = "BUSINESS_HOURS_START",
  BUSINESS_HOURS_END = "BUSINESS_HOURS_END"
}

/** Status of user */
export enum UserStatus {
  VERIFIED = "VERIFIED",
  UNVERIFIED = "UNVERIFIED",
  DISABLED = "DISABLED"
}

export interface AdminUpdateUserRequestBody {
  businessId?: number;
  /** Status of user */
  status: UserStatus;
}

/** Request body to decline a bid that is currently in ACCEPTED state (auction must be in OFFER_ACCEPTED state). */
export interface AdminDeclineAcceptedBidBody {
  action: "DECLINE_ACCEPTED_BID";
  bidId: number;
}

/** Enum of auction states an admin user can update with. */
export enum AdminUpdateAuctionState {
  CANCELLED = "CANCELLED",
  DELETED = "DELETED",
  BILLED = "BILLED",
  SOLD = "SOLD"
}

/** Request body when Admin updates auction's end_time */
export interface AdminUpdateAuctionEndTimeBody {
  /**
   * ISO Date string
   * @format date-time
   */
  endTime: string;
}

/** Request body when Admin updates auction's state without the need for additional data. */
export interface AdminUpdateAuctionStateBody {
  /** Enum of auction states an admin user can update with. */
  auctionState: AdminUpdateAuctionState;
}

/** Request body when Admin updates auction's state that is NOT_SOLD || REJECTED_BY_DEALER to OFFER_ACCEPTED. Requires bidId of offer that is OFFER_ACCEPTED. */
export interface AdminUpdateAuctionStateWithBidBody {
  auctionState: "OFFER_ACCEPTED";
  bidId: number;
}

export type AdminUpdateAuctionBody =
  | AdminUpdateAuctionEndTimeBody
  | AdminUpdateAuctionStateBody
  | AdminUpdateAuctionStateWithBidBody
  | AdminDeclineAcceptedBidBody;

/** Request body when Admin updates auctionItem details */
export interface AdminUpdateAuctionItemBody {
  targetPrice?: number;
  /**
   * @minLength 1
   * @pattern .*\S.*
   */
  regNo?: string;
}

/** Severity of Announcement */
export enum AnnouncementSeverity {
  Error = "error",
  Warning = "warning",
  Info = "info",
  Success = "success"
}

export interface Announcement {
  content: string;
  /**
   * Start date of announcement visibility
   * @format date-time
   */
  startDate: string;
  /**
   * End date of announcement visibility
   * @format date-time
   */
  endDate: string;
  /** Severity of Announcement */
  severity: AnnouncementSeverity;
  /** Optional property to show announcement only to a limited audience. `undefined` means visible to all */
  audience?: UserRole;
}

/** Filter auctions by parameter enum */
export enum ListAuctionsFilterParam {
  OwnBids = "own_bids",
  Ended = "ended",
  Active = "active",
  Accepted = "accepted",
  Finalized = "finalized",
  InNegotiation = "in_negotiation",
  Pending = "pending",
  Lost = "lost",
  Declined = "declined"
}

/**
 * EventTypes that are stored to DB and displayed in user's notification center: \
 *  - `BID_DECLINED` - Seller has declined an offer (bid)
 *  - `ADMIN_BID_DECLINED` - Admin has declined an accepted offer (bid)
 *  - `BID_UPDATED` - Buyer updated it's bid amount
 *  - `BID_UPDATED_AND_STATE_CHANGE` = Buyer updated bid amount and changed state
 *  - `BID_ACCEPTED` - Seller has accepted an offer (bid) or Dealer has marked as preliminary deal
 *  - `AUCTION_MARKED_SOLD` = Auction has been marked as sold by dealer
 *  - `OFFER_WITHDRAWN` - Buyer has withdrawn it's offer
 *  - `FINAL_OFFER_AVAILABLE` - Top bidder can submit a final offer after all offers were declined
 *  - `FINAL_OFFER_RECEIVED` - Final offer was submitted by dealer and is pending consumer review
 *  - `NEW_NEGOTIATION_MESSAGE` - New negotiation message for user
 *  - `NEW_QUESTION` - New question for auction
 *  - `NEW_ANSWER` - New answer for auction
 *  - `NEW_BIDS_OUTBIDDED` - Your bid was outbidded in auction
 *  - `AUCTION_ENDED` - Auction has ended (a subset of AUCTION_STATE_CHANGE)
 *  - `TARGET_PRICE_REACHED` - Seller's target price has been exceeded for the first time
 *  - `FIRST_BID` - First bid posted
 *  - `AUCTION_STATE_CHANGE` - Auction state has changed
 *  - `NEW_PATCH` - New site message available
 *  - `BADGE_NOTIFICATION_PENDING` - Auction is pending dealer action
 *  - `BADGE_NOTIFICATION_IN_NEGOTIATION` - Auction is in negotiation
 *  - `BADGE_NOTIFICATION_ACCEPTED` - Auction offer was accepted
 *  - `BADGE_NOTIFICATION_DECLINED` - Auction offer was declined
 *  - `REMINDER_TO_MARK_SOLD` - Dealer is reminded to mark an accepted offer as sold
 *  - `NEGOTIATION_EXTENDED` - Consumer extended negotiation on a NOT_SOLD auction, reactivating the dealer's bid
 */
export enum NotificationEventType {
  BID_DECLINED = "BID_DECLINED",
  ADMIN_BID_REMOVED = "ADMIN_BID_REMOVED",
  ADMIN_BID_MODIFIED = "ADMIN_BID_MODIFIED",
  ADMIN_BID_DECLINED = "ADMIN_BID_DECLINED",
  BID_UPDATED = "BID_UPDATED",
  BID_UPDATED_AND_STATE_CHANGE = "BID_UPDATED_AND_STATE_CHANGE",
  BID_ACCEPTED = "BID_ACCEPTED",
  AUCTION_MARKED_SOLD = "AUCTION_MARKED_SOLD",
  OFFER_WITHDRAWN = "OFFER_WITHDRAWN",
  NEW_NEGOTIATION_MESSAGE = "NEW_NEGOTIATION_MESSAGE",
  NEW_QUESTION = "NEW_QUESTION",
  NEW_ANSWER = "NEW_ANSWER",
  NEW_BIDS_OUTBIDDED = "NEW_BIDS_OUTBIDDED",
  AUCTION_ENDED = "AUCTION_ENDED",
  TARGET_PRICE_REACHED = "TARGET_PRICE_REACHED",
  FIRST_BID = "FIRST_BID",
  AUCTION_STATE_CHANGE = "AUCTION_STATE_CHANGE",
  NEW_PATCH = "NEW_PATCH",
  BADGE_NOTIFICATION_PENDING = "BADGE_NOTIFICATION_PENDING",
  BADGE_NOTIFICATION_IN_NEGOTIATION = "BADGE_NOTIFICATION_IN_NEGOTIATION",
  BADGE_NOTIFICATION_ACCEPTED = "BADGE_NOTIFICATION_ACCEPTED",
  BADGE_NOTIFICATION_DECLINED = "BADGE_NOTIFICATION_DECLINED",
  AUCTION_ADDITIONAL_INFO_ADDED = "AUCTION_ADDITIONAL_INFO_ADDED",
  FINAL_OFFER_AVAILABLE = "FINAL_OFFER_AVAILABLE",
  FINAL_OFFER_RECEIVED = "FINAL_OFFER_RECEIVED",
  REMINDER_TO_MARK_SOLD = "REMINDER_TO_MARK_SOLD",
  NEGOTIATION_EXTENDED = "NEGOTIATION_EXTENDED"
}

/**
 * Enum of different event types sent via AWS IoT to client \
 * - `BID_SUCCESS`
 *   Bid successfully placed and is in the lead
 * - `BID_FAILED`
 *   Bid failed because of server error or is too low at the time of handling
 * - `BID_FAILED_OTHER_BID_MACHINE_GOT_BID`
 *   Bid failed due to another bid machine bidding the bidded amount
 * - `BID_SUCCESS_OTHER_BID_MACHINE_RAISED`
 *   Bid successfully placed, but was instantly overbidden by a bid machine
 * - `BID_DECLINED`
 *   Seller has declined an offer (bid)
 * - `ADMIN_BID_DECLINED`
 *   Admin has declined an accepted offer (bid)
 * - `NEW_BIDS`
 *   Auction has new bids
 * - `AUCTION_STATE_CHANGE`
 *   Auction state has changed
 * - `AUCTION_ITEM_UPDATED`
 *   Auction item has been updated by admin
 * - `NEW_NEGOTIATION_MESSAGE`
 *   New negotiation message for user
 * - `NEW_QUESTION`
 *   New question for auction
 * - `NEW_ANSWER`
 *   New answer for auction
 * - `NEW_BIDS_OUTBIDDED`
 *   Your bid was outbidded in auction
 * - `NEW_AUCTION`
 *   New auction posted
 * - `NEW_ANNOUNCEMENT`
 *   Announcements have been updated
 * - `QA_DELETED`
 *   Question or answer has been deleted by user
 * - `NEW_PATCH`
 *   New site message available
 * - `BADGE_NOTIFICATION_PENDING`
 *   Pending badge notification
 * - `BADGE_NOTIFICATION_IN_NEGOTIATION`
 *   In negotiation badge notification
 * - `BADGE_NOTIFICATION_ACCEPTED`
 *   Accepted badge notification
 * - `BADGE_NOTIFICATION_DECLINED`
 *   Declined badge notification
 * - `FINAL_OFFER_AVAILABLE`
 *   Top bidder can submit a final offer
 * - `FINAL_OFFER_RECEIVED`
 *   Final offer was received from dealer
 */
export enum IoTEventType {
  BID_SUCCESS = "BID_SUCCESS",
  BID_FAILED = "BID_FAILED",
  BID_FAILED_OTHER_BID_MACHINE_GOT_BID = "BID_FAILED_OTHER_BID_MACHINE_GOT_BID",
  BID_SUCCESS_OTHER_BID_MACHINE_RAISED = "BID_SUCCESS_OTHER_BID_MACHINE_RAISED",
  BID_DECLINED = "BID_DECLINED",
  ADMIN_BID_REMOVED = "ADMIN_BID_REMOVED",
  ADMIN_BID_MODIFIED = "ADMIN_BID_MODIFIED",
  ADMIN_BID_DECLINED = "ADMIN_BID_DECLINED",
  BID_UPDATED = "BID_UPDATED",
  BID_UPDATED_AND_STATE_CHANGE = "BID_UPDATED_AND_STATE_CHANGE",
  AUCTION_MARKED_SOLD = "AUCTION_MARKED_SOLD",
  NEW_BIDS = "NEW_BIDS",
  AUCTION_STATE_CHANGE = "AUCTION_STATE_CHANGE",
  AUCTION_ITEM_UPDATED = "AUCTION_ITEM_UPDATED",
  NEW_NEGOTIATION_MESSAGE = "NEW_NEGOTIATION_MESSAGE",
  NEW_QUESTION = "NEW_QUESTION",
  NEW_ANSWER = "NEW_ANSWER",
  NEW_BIDS_OUTBIDDED = "NEW_BIDS_OUTBIDDED",
  NEW_AUCTION = "NEW_AUCTION",
  NEW_ANNOUNCEMENT = "NEW_ANNOUNCEMENT",
  QA_DELETED = "QA_DELETED",
  NEW_PATCH = "NEW_PATCH",
  BADGE_NOTIFICATION_PENDING = "BADGE_NOTIFICATION_PENDING",
  BADGE_NOTIFICATION_IN_NEGOTIATION = "BADGE_NOTIFICATION_IN_NEGOTIATION",
  BADGE_NOTIFICATION_ACCEPTED = "BADGE_NOTIFICATION_ACCEPTED",
  BADGE_NOTIFICATION_DECLINED = "BADGE_NOTIFICATION_DECLINED",
  AUCTION_ADDITIONAL_INFO_ADDED = "AUCTION_ADDITIONAL_INFO_ADDED",
  FINAL_OFFER_AVAILABLE = "FINAL_OFFER_AVAILABLE",
  FINAL_OFFER_RECEIVED = "FINAL_OFFER_RECEIVED"
}

/** IoT PubSub message */
export interface IoTMessage {
  auctionId?: number;
  /** Current state of auction TODO Explanation */
  auctionState?: AuctionState;
  /**
   * Enum of different event types sent via AWS IoT to client \
   * - `BID_SUCCESS`
   *   Bid successfully placed and is in the lead
   * - `BID_FAILED`
   *   Bid failed because of server error or is too low at the time of handling
   * - `BID_FAILED_OTHER_BID_MACHINE_GOT_BID`
   *   Bid failed due to another bid machine bidding the bidded amount
   * - `BID_SUCCESS_OTHER_BID_MACHINE_RAISED`
   *   Bid successfully placed, but was instantly overbidden by a bid machine
   * - `BID_DECLINED`
   *   Seller has declined an offer (bid)
   * - `ADMIN_BID_DECLINED`
   *   Admin has declined an accepted offer (bid)
   * - `NEW_BIDS`
   *   Auction has new bids
   * - `AUCTION_STATE_CHANGE`
   *   Auction state has changed
   * - `AUCTION_ITEM_UPDATED`
   *   Auction item has been updated by admin
   * - `NEW_NEGOTIATION_MESSAGE`
   *   New negotiation message for user
   * - `NEW_QUESTION`
   *   New question for auction
   * - `NEW_ANSWER`
   *   New answer for auction
   * - `NEW_BIDS_OUTBIDDED`
   *   Your bid was outbidded in auction
   * - `NEW_AUCTION`
   *   New auction posted
   * - `NEW_ANNOUNCEMENT`
   *   Announcements have been updated
   * - `QA_DELETED`
   *   Question or answer has been deleted by user
   * - `NEW_PATCH`
   *   New site message available
   * - `BADGE_NOTIFICATION_PENDING`
   *   Pending badge notification
   * - `BADGE_NOTIFICATION_IN_NEGOTIATION`
   *   In negotiation badge notification
   * - `BADGE_NOTIFICATION_ACCEPTED`
   *   Accepted badge notification
   * - `BADGE_NOTIFICATION_DECLINED`
   *   Declined badge notification
   * - `FINAL_OFFER_AVAILABLE`
   *   Top bidder can submit a final offer
   * - `FINAL_OFFER_RECEIVED`
   *   Final offer was received from dealer
   */
  type: IoTEventType;
  /** Badge notification type when type is BADGE_NOTIFICATION */
  badgeType?: NotificationEventType;
}

/** IoT PubSub payload */
export interface IoTPayload {
  /** PubSub topic */
  topic: string;
  /** IoT PubSub message */
  message: IoTMessage;
}

export interface CreateNegotiationMessageBody {
  bidId: number;
  /** @minLength 1 */
  message: string;
}

export interface NegotiationMessageDTO {
  id: number;
  bidId: number;
  userId: number;
  content: string;
  /** Name of user who sent message. Exists if sender is from own organization and not user itself. */
  userName?: string;
  /**
   * When negotiation message was created
   * @format date-time
   */
  createdAt: string;
  /** Is message generated by system (not counted towards maximum message count) */
  isSystemGenerated?: boolean;
  /** Is message read by dealer */
  isRead?: boolean;
}

export interface WithdrawOfferRequestBody {
  /**
   * Reason to withdraw offer
   * @minLength 1
   */
  reason: string;
}

/** Question/Answer object for auction where dealer has asked question and seller possibly answered */
export interface AuctionQuestionDTO {
  id: number;
  question: string;
  answer?: string;
  /** @format date-time */
  answeredAt?: string;
  /** UserId of asker */
  userId: number;
  /** @format date-time */
  createdAt: string;
  /** Dealer who asked the question */
  dealer?: {
    firstName: string;
    lastName: string;
    businessName: string;
  };
  answers?: AuctionAnswerDTO[];
  /** Is question deleted by user */
  isDeleted?: boolean;
}

export interface AuctionAnswerDTO {
  id: number;
  answer: string;
  /** @format date-time */
  createdAt: string;
  /** UserId of answerer */
  userId: number;
  /** User (seller) who wrote the answer */
  user?: {
    firstName: string;
    lastName: string;
  };
  /** Is answer deleted by user */
  isDeleted?: boolean;
}

/** Additional information added to auction after publication */
export interface AuctionAdditionalInfoDTO {
  id: number;
  auctionId: number;
  userId: number;
  additionalInfo?: string | null;
  /** @format date-time */
  createdAt: string;
  user: {
    id: number;
    firstName: string;
    lastName: string;
    role: string;
  };
  media: {
    id: number;
    key: string;
    from: string;
    /** Hosting service the media is uploaded to */
    mediaService: MediaService;
  }[];
}

export interface GetServerTimeResponseBody {
  /** Difference between provided client time in milliseconds and server time when handled */
  serverClientDiffMs?: number;
  /** Server milliseconds when request is handled */
  serverTimeMs?: number;
}

export interface GetNettixTokenResponseBody {
  /** Nettix API public access token */
  token: string;
}

export interface CreateNoteRequestBody {
  /**
   * Content of note
   * @minLength 1
   */
  content: string;
}

export interface NoteDTO {
  id: number;
  userId: number;
  user: {
    firstName: string;
    lastName: string;
    businessName: string;
  };
  content: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  modifiedAt: string;
}

export interface PreviousAuctionNoteDTO {
  id: number;
  userId: number;
  user: {
    firstName: string;
    lastName: string;
    businessName: string;
  };
  content: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  modifiedAt: string;
  auctionId: number;
  /** @format date-time */
  auctionCreatedAt: string;
  /** @format date-time */
  auctionEndedAt?: string | null;
  /** Current state of auction TODO Explanation */
  auctionState: AuctionState;
  /** Mileage difference vs. the current auction, in kilometres. Omitted (null) when either mileage value is missing or non-numeric. */
  mileageDelta?: number | null;
}

export interface CreateAuctionFlagRequestBody {
  /**
   * Reason for reporting the auction
   * @minLength 1
   * @maxLength 500
   */
  reason: string;
}

export interface AuctionFlagDTO {
  id: number;
  auctionId: number;
  dealerId: number;
  reason: string;
  status: string;
  /** @format date-time */
  createdAt: string;
  dealer: {
    firstName: string;
    lastName: string;
    businessName: string;
  };
}

/** Messaging preferences that are in both email and sms */
export interface CommonMessagePreferences {
  consumerAuctionEnded?: boolean;
  consumerTargetPriceReached?: boolean;
  consumerNewNegotiationMessage?: boolean;
  consumerQuestionAsked?: boolean;
  dealerOfferAccepted?: boolean;
  dealerOutBidded?: boolean;
  dealerNewNegotiationMessage?: boolean;
  dealer5minWarning?: boolean;
}

/** User email notification preferences. Undefined is treated as true. */
export type EmailPreferences = CommonMessagePreferences & {
  consumerAuctionEndedNoBids?: boolean;
  consumerAuctionStarted?: boolean;
  consumerDealerRaisedBid?: boolean;
  consumerFirstBidNotification?: boolean;
  dealerAuctionDeleted?: boolean;
  dealerAuctionEnded?: boolean;
  dealerDailyInfoEmail?: boolean;
  /** Google review request emails */
  googleReviewEmails?: boolean;
  /** Draft reminder emails */
  draftReminderEmails?: boolean;
};

/** User sms notification preferences. Undefined is treated as true. */
export type SMSPreferences = CommonMessagePreferences & {
  consumer4HourWarning?: boolean;
  consumerQuestionAsked?: boolean;
  consumerDealerRaisedBid?: boolean;
  consumerFinalOfferReceived?: boolean;
  dealerQuestionAnswered?: boolean;
  dealer15minWarning?: boolean;
};

export interface UserPreferences {
  notifications?: {
    /** User email notification preferences. Undefined is treated as true. */
    email?: EmailPreferences;
    /** User sms notification preferences. Undefined is treated as true. */
    sms?: SMSPreferences;
  };
  dealer?: {
    pickupIncluded?: boolean;
    bidAlwaysIncludePickUp?: boolean;
    excludeOrganizationBids?: boolean;
    /** Percentage of guaranteed amount from bid amount */
    guaranteedAmountPercentage?: number;
    /** Dealer preference - keep ended auctions visible in-place on the active auctions list until refresh or filter/sort change */
    keepEndedAuctionsVisible?: boolean;
  };
  /** JSON-serialised UserAddress snapshot taken before the business flow overwrites User.address */
  personalAddressSnapshot?: string;
}

export interface UserNotificationDTO {
  id: number;
  /**
   * EventTypes that are stored to DB and displayed in user's notification center: \
   *  - `BID_DECLINED` - Seller has declined an offer (bid)
   *  - `ADMIN_BID_DECLINED` - Admin has declined an accepted offer (bid)
   *  - `BID_UPDATED` - Buyer updated it's bid amount
   *  - `BID_UPDATED_AND_STATE_CHANGE` = Buyer updated bid amount and changed state
   *  - `BID_ACCEPTED` - Seller has accepted an offer (bid) or Dealer has marked as preliminary deal
   *  - `AUCTION_MARKED_SOLD` = Auction has been marked as sold by dealer
   *  - `OFFER_WITHDRAWN` - Buyer has withdrawn it's offer
   *  - `FINAL_OFFER_AVAILABLE` - Top bidder can submit a final offer after all offers were declined
   *  - `FINAL_OFFER_RECEIVED` - Final offer was submitted by dealer and is pending consumer review
   *  - `NEW_NEGOTIATION_MESSAGE` - New negotiation message for user
   *  - `NEW_QUESTION` - New question for auction
   *  - `NEW_ANSWER` - New answer for auction
   *  - `NEW_BIDS_OUTBIDDED` - Your bid was outbidded in auction
   *  - `AUCTION_ENDED` - Auction has ended (a subset of AUCTION_STATE_CHANGE)
   *  - `TARGET_PRICE_REACHED` - Seller's target price has been exceeded for the first time
   *  - `FIRST_BID` - First bid posted
   *  - `AUCTION_STATE_CHANGE` - Auction state has changed
   *  - `NEW_PATCH` - New site message available
   *  - `BADGE_NOTIFICATION_PENDING` - Auction is pending dealer action
   *  - `BADGE_NOTIFICATION_IN_NEGOTIATION` - Auction is in negotiation
   *  - `BADGE_NOTIFICATION_ACCEPTED` - Auction offer was accepted
   *  - `BADGE_NOTIFICATION_DECLINED` - Auction offer was declined
   *  - `REMINDER_TO_MARK_SOLD` - Dealer is reminded to mark an accepted offer as sold
   *  - `NEGOTIATION_EXTENDED` - Consumer extended negotiation on a NOT_SOLD auction, reactivating the dealer's bid
   */
  notificationEventType?: NotificationEventType;
  /** Relative URL */
  actionUrl?: string;
  isRead: boolean;
  contentData?: NotificationContentData;
  /** @format date-time */
  createdAt: string;
}

export interface NotificationContentData {
  regNo?: string;
  makeModel?: string;
  auctionId?: number;
  oldBidAmount?: number;
  newBidAmount?: number;
}

export interface AuctionsSummary {
  /** Amount of `STARTED` auctions user or it's organization has bids in. */
  started: number;
  /** Amount of ended auctions (ENDED, NOT_SOLD etc..) user has had bids in. */
  ended: number;
  /** Amount of `OFFER_ACCEPTED` auctions user has had bid in */
  accepted: number;
  /** Amount of `ENDED` auctions that user's bid is `IN_NEGOTIATION` */
  inNegotiation: number;
  /** Amount of `ENDED` auctions that user's bid is in `OK` state */
  waitingForSeller: number;
  /** Amount of `SOLD | BILLED` auctions with user's bid as `accepted_bid_id` */
  finalized: number;
  /** Amount of ended auctions (ENDED, NOT_SOLD etc..) user or it's organization has had bids in but lost. */
  lost: number;
  /** Amount of `ENDED` or `NOT_SOLD` auctions from the last 21 days where user's / org's bid is `DECLINED` */
  declined: number;
}

export interface GdprUserAddress {
  streetAddress?: string;
  postalCode?: string;
  city?: string;
  country?: string;
}

export interface GdprUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  phoneNumber?: string;
  address?: GdprUserAddress;
  /** @format date-time */
  createdAt: string;
}

export interface GdprVehicle {
  id: number;
}

export interface GdprAuction {
  id: number;
  auctionState: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  /** @format date-time */
  offerEndTime?: string;
}

export interface GDPRUserResponse {
  user: GdprUser;
  vehicles?: GdprVehicle[];
  auctions?: GdprAuction[];
}

export interface ServiceInformation {
  content: string;
  /** @format date-time */
  updatedAt: string;
}

export interface Dac7ReminderEmailData {
  userInfo: {
    /** User's first name */
    name: string;
  };
  /** URL to DAC7 information page */
  loginUrl: string;
  /** Number of days until account closure */
  numOfDays: number;
  /** Type of DAC7 reminder being sent */
  reminderType: "first" | "second";
}

export interface VerticalCheckResult {
  /** ID of the auction */
  auctionId: number;
  /** Vehicle registration number */
  regNo: string;
  /** Business ID (Y-tunnus) */
  yTunnus: string;
  /** Platform where listing was found */
  vertical: VerticalSource;
  /** Name of the business with the listing */
  businessName?: string | null;
  /**
   * Date when the listing was posted
   * @format date-time
   */
  listingDate?: string | null;
  /** Status of the listing (e.g., FORSALE, SOLD) */
  listingStatus?: string | null;
  /** Link to the ad */
  adLink?: string | null;
  /** Review status of the vertical check result */
  reviewStatus: "NEW" | "REVIEWED";
  /**
   * When the result was marked as reviewed
   * @format date-time
   */
  reviewedAt?: string | null;
  /**
   * When the record was created
   * @format date-time
   */
  createdAt: string;
  /**
   * When the record was last updated
   * @format date-time
   */
  updatedAt: string;
}

export interface VerticalCheckSummary {
  /** Number of new (unreviewed) vertical check results */
  newCount: number;
  /** Number of reviewed vertical check results */
  reviewedCount: number;
  /** Total number of vertical check results */
  totalCount: number;
}

export interface VerticalChecksResponse {
  /** Array of new (unreviewed) vertical check results */
  new: VerticalCheckResult[];
  /** Array of reviewed vertical check results */
  reviewed: VerticalCheckResult[];
  /** Summary statistics (optional, included when includeSummary=true) */
  summary?: VerticalCheckSummary | null;
  /** Total count of all results */
  totalCount: number;
}

export interface PresignedUrlResponse {
  presignedUrl: string;
  /** generated S3 key */
  key: string;
}

export interface UnsubscribeStatusResponse {
  emailType: string;
  currentPreferences: Record<string, any>;
  token: string;
}

export interface UnsubscribeFromEmailsRequest {
  /** Unsubscribe token from email */
  token: string;
  /** Whether to unsubscribe from all marketing emails */
  unsubscribeAll?: boolean;
}

export interface UnsubscribeFromEmailsResponse {
  message?: string;
  unsubscribedFrom?: string[];
}

/** A bid row in the admin top-bids list for an auction */
export interface AdminTopBid {
  bidId: number;
  amount: number;
  userId: number;
  userName: string;
  /** Null if not set on the user's profile */
  businessName?: string | null;
  /** @format date-time */
  createdAt: string;
}

// Hand-written admin types below this point: `generatetypes` only reads the
// main API spec, so these are not generated and must be re-added after every
// regeneration of this file.

export interface AdminNoteDTO {
  id: number;
  auctionId: number;
  content: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface AdminNoteUpsertBody {
  content: string;
}

export interface BillingReportUrlResponse {
  presignedUrl: string;
}

export interface AdminAuctionFlagDTO {
  id: number;
  auctionId: number;
  regNo: string | null;
  make: string | null;
  model: string | null;
  modelYear: number | null;
  dealer: {
    id: number;
    firstName: string;
    lastName: string;
    businessName: string;
  };
  reason: string;
  /** @format date-time */
  createdAt: string;
}

export interface AdminAuctionFlagUpdateBody {
  status: "resolved";
}
